import gql from 'graphql-tag';

// Get profile data
export const GET_MENTOR_REQUEST = gql`
query get_mentor_request($id: ID!, $idType: String) {
    mentorRequest(id: $id, idType: $idType) {
        id
        mentor_request_id
        title
        content
        slug
        mentor_id
        mentor_user_id
        mentee_id
        permalink
        status
        venture_id
        problem
        introduction
    }
}
`;
// Get single mentor request with mentee data
export const GET_SINGLE_MENTOR_REQUEST = gql`
  query get_mentor_request($id: ID!, $idType: String, $postId: Int) {
    mentorRequest(id: $id, idType: $idType) {
        id
        mentor_request_id
        title
        content
        slug
        mentor_id
        mentor_user_id
        mentee_id
        permalink
        status
        venture_id
        problem_formatted
        introduction_formatted
        startdate
        enddate
        date
        agreement_date
        duration_number
        duration_unit
        meetings_number
        meetings_unit
        challenges
        goals
        program_title
        program_tagline
        program_url
        program_logo
        program_page_url
        uses_internal_scheduling
        menteeAccount {
            id
            userId
            name
            city
            country
            avatar_url
            permalink
            close_pending
            ventures {
                nodes {
                    id
                    venture_id
                    title
                    logo_url
                    tagline
                    permalink
                }
            }
        }
        mentorAccount {
            id
            userId
            name
            city
            country
            avatar_url
            permalink
            close_pending
        }
        mentorProfile {
            id
            mentor_id
            title
            slug
            avatar_url
            avatar_thumb_url
            organization
            role
            city
            duration
            permalink
            author
        }
        moderatorAccount {
            id
            name
            email_address
            avatar_url
        }
    }
    topic: terms(first: 1000, where: {taxonomySlug: "topic", postId: $postId, siteId: 1} ) {
        edges {
            cursor
            node {
                id
                term_id
                name
                slug
                name__fr_FR
                name__es_ES
            }
        }
    }
}
`;


export const CREATE_MENTOR_REQUEST = gql`
  mutation create_mentor_request($input: CreateMentorRequestInput!) {
    createMentorRequest(input: $input) {
        id
        permalink
        status
    }
}
`;


// Retrieve/mutate mentor request data
export const UPDATE_MENTOR_REQUEST_STATUS = gql`
  mutation update_mentor_request_status($input: UpdateMentorRequestStatusInput!) {
    updateMentorRequestStatus(input: $input) {
        mentor_request_id
        status
    }
}
`;


// Close review mutation.
export const CLOSE_MENTOR_REQUEST = gql`
  mutation close_mentor_request($input: CloseMentorRequestInput!) {
    closeMentorRequest(input: $input) {
        mentor_request_id
        user_id
        feedback_option
        feedback
        rating
        review
        use_review
    }
}
`;

export const GET_MY_MENTOR_INBOX_REQUESTS = gql`
  query get_my_mentor_requests($first:Int, $after: String, $where: ConnectionMentorRequestsWhereArgs) {
    mentorRequests(first: $first, after: $after, where: $where) {
        pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
            resultTotal
        }
        edges {
            cursor
            node {
                id
                permalink
                status
                date
                menteeAccount {
                    id
                    name
                    avatar_url
                    permalink
                    ventures{
                        nodes{
                            id
                            title
                            logo_url
                            permalink
                        }
                    }
                }
            }
        }
    }
}
`;

export const GET_MY_MENTOR_REQUEST_STATUS_COUNTS = gql`
  query get_mentor_request_status_counts($where: ConnectionMentorRequestsWhereArgs) {
    mentorRequests(where: $where) {
        pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
            resultTotal
        }
        edges {
            cursor
            node {
                id
                mentor_request_id
                status
            }
        }
    }
}
`;

// Get profile data
export const GET_MENTOR_REQUEST_AGREEMENT = gql`
  query get_mentor_request($id: ID!, $idType: String) {
    mentorRequest(id: $id, idType: $idType) {
        id
        title
        mentor_request_id
        agreement_date
        duration_number
        duration_unit
        meetings_number
        meetings_unit
        challenges
        goals
        reject_reason
        mentorProfile {
            title
        }
        menteeAccount {
            name
        }
    }
}
`;


// Update mentor request agreement.
export const UPDATE_MENTOR_REQUEST_AGREEMENT = gql`
  mutation update_mentor_request($input: UpdateMentorRequestInput!) {
    updateMentorRequest(input: $input) {
        id
        mentor_request_id
        agreement_date
        duration_number
        duration_unit
        meetings_number
        meetings_unit
        challenges
        goals
        reject_reason
        permalink
    }
}
`;
